<h3 style="display:inline-block">Beacon Sensor Configuration</h3>
<div *ngIf="beacons.length < 1"><b>You have no beacons configured yet for your organization. Please, contact the adminstrator!</b></div>
<button class="btn btn-info btn-sm" style="float:right;margin-top:5px" (click)="showInstructions = !showInstructions">Beacon Configuration Help</button>
<div *ngIf="showInstructions" style="border:solid 1px rgb(0, 0, 0);border-radius:5px;margin:10px;padding:10px;background-color: rgb(242, 242, 242);">
    <h5>Instructions</h5>
    <div class="row">
        <div class="col-md-7">
            In this page you can associate a beacon with a sensor.
            For each sensor you specify the parameters that define the display on the mobile (see graph on the right).
            <ul>
                <li>Alarm Threshold: The value of the sensor from which the alarm will fire</li>
                <li>Max Value: The maximum value that the sensor will show for this spill. Note: Several beacons can add up to a higher value displayed.</li>
                <li>Min Distance: The distance below which the maximum value will be simulated</li>
                <li>Max Distance: The distance beyond which the value is set to zero.</li>
            </ul>
            <br><br>
            <b>Once all sensors are configured, you should test the configuration using you mobile phone app.</b>
            <br>
            You can find the mobile app in the google play store under "cellpodium" (right now select "new")
        </div>
        <div class="col-md-5">
            <img src="../../../assets/BeaconDistancePicture.jpg" alt="distance function" style="width:100%" />
        </div>
    </div>


</div>
<div class="row">
    <div class="col-md-3" hidden="hidden">
        <div style="border:solid 1px gray;margin-left:10px;padding:5px">
            <b>Edit Beacon Sensor Configurations</b>
            <!-- <button class="btn btn-primary" (click)="clearBeaconSensor()">Add New Beacon Sensor Configuration</button> -->
            <div class="row">
                <div class="col-md-6">
                    <sa-select [(Id)]="beaconsensor.beaconId" [title]="'Beacon'" [options]="beacons"></sa-select>
                    <!-- <sa-input-number [(text)]="beaconsensor.seqNo" [title]="'Sequence'" [required]="'none'"></sa-input-number> -->
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-8"><sa-select [(Id)]="beaconsensor.sensorId" [title]="'Sensor'" [options]="sensors" (hasChanged)="sensorhaschanged()"></sa-select></div>
                        <div class="col-md-4 align-self-end">
                            <div>{{beaconsensor.sensorunits}}</div>
                        </div>
                    </div>

                </div>
            </div>
            <br><br>
            <div class="row">
                <div class="col-md-6">
                    <sa-input-number [(text)]="beaconsensor.minDistance" [title]="'Min Distance [feet]'" [required]="'none'"></sa-input-number>
                    <br><br>
                    <div class="row">
                        <div class="col-md-8"><sa-input-number [(text)]="beaconsensor.maxValue" [title]="'Max Value'" [required]="'none'" (hasChanged)="sensorhaschanged()"></sa-input-number>
                        </div>
                        <div class="col-md-4 align-self-end">
                            <div>{{beaconsensor.sensorunits}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <sa-input-number [(text)]="beaconsensor.maxDistance" [title]="'Max Distance [feet]'" [required]="'none'"></sa-input-number>
                    <br><br>
                    <sa-input-number [(text)]="beaconsensor.threshold" [title]="'Threshold'" [required]="'none'"></sa-input-number>
                </div>
            </div>
            <br>
            <button *ngIf="beaconsensor.id > 0" class="btn btn-primary" (click)="save()">Save</button>
            <button *ngIf="beaconsensor.id == 0" class="btn btn-primary" (click)="save()">Add</button>
            <button *ngIf="beaconsensor.id > 0" class="btn btn-secondary" style="float:right" (click)="clearBeaconSensor()">Clear</button>
            <!-- <button class="btn btn-primary" (click)="clearBeaconSensor()" style="float:right">Clear</button> -->
            <div *ngIf="validationObject.result == false">
                <b>Validation Error</b>
                <div *ngFor="let m of validationObject.messages">
                    {{m}}
                </div>
            </div>
        </div>



    </div>

    <div class="col-md-6">
        <b>List of Sensor / Beacon Configuration</b>
        <button class="btn btn-primary" style="float:right" (click)="detailModal(null)">Add New Configuration</button>
        <br><br>
        <table class="table table-bordered">
            <tbody>
                <tr *ngFor="let bsg of bsgroups">
                    <td>
                        <img *ngIf="bsg.beacon?.picUrl?.length > 3" [src]="'../../../assets/beacons/'+bsg.beacon.picUrl" alt="beacon" style="max-width:50px" /><br>
                        {{bsg.beacon?.name}}
                    </td>
                    <td>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Edit</th>
                                    <th>Sequence</th>
                                    <th>Sensor</th>
                                    <th>Min-Max Distance</th>
                                    <th>Max Value</th>
                                    <th>Threshold</th>
                                    <th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let bs of bsg.values">
                                    <td><i class="bi bi-pencil" style="color:green" (click)="edit(bs)"></i></td>
                                    <td>{{bs.seqNo}}</td>
                                    <td>{{lookup(bs.sensorId,sensors)}}</td>
                                    <td>{{bs.minDistance}} - {{bs.maxDistance}}</td>
                                    <td>{{bs.maxValue}}</td>
                                    <td>{{bs.threshold}}</td>
                                    <td><i class="bi bi-trash" style="color:orange" (click)="remove(bs)"></i></td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
    <div class="col-md-1"></div>
    <div class="col-md-2">
        <b>Student View on Mobile</b><br>
        Values are examples only.<br>
        <div style="padding:15px 5px 15px 5px;background-color:gray;border-radius:5px">
            <div style="border:solid 1px gray;height:300px;padding:10px;background-color:white">
                <span>Sensor Simulator</span><br>
                <table class="table">
                    <tbody>
                        <tr *ngFor="let d of mobiledisplay">
                            <td>{{d.name}}</td>
                            <td>
                                <div style="border:solid 1px black;min-width:80px;display:inline-block;padding-left:5px"> 20 </div>
                            </td>
                            <td>{{d.units}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- Modal -------------------------------------------------------------------------------------->
<div *ngIf="showModal" #testmodal class="cpmodal" >
    <div class="cpmodal-content" style="max-width:600px">
        <h5>Edit Details of Beacon Scneario</h5>
        <div style="border:solid 1px gray;margin-left:10px;padding:5px">
            <b>Edit Beacon Sensor Configurations</b>
            <!-- <button class="btn btn-primary" (click)="clearBeaconSensor()">Add New Beacon Sensor Configuration</button> -->
            <div class="row">
                <div class="col-md-6">
                    <sa-select [(Id)]="beaconsensor.beaconId" [title]="'Beacon'" [options]="beacons"></sa-select>
                    <!-- <sa-input-number [(text)]="beaconsensor.seqNo" [title]="'Sequence'" [required]="'none'"></sa-input-number> -->
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-8"><sa-select [(Id)]="beaconsensor.sensorId" [title]="'Sensor'" [options]="sensors" (hasChanged)="sensorhaschanged()"></sa-select></div>
                        <div class="col-md-4 align-self-end">
                            <div>{{beaconsensor.sensorunits}}</div>
                        </div>
                    </div>

                </div>
            </div>
            <br><br>
            <div class="row">
                <div class="col-md-6">
                    <sa-input-number [(text)]="beaconsensor.minDistance" [title]="'Min Distance [feet]'" [required]="'none'"></sa-input-number>
                    <br><br>
                    <div class="row">
                        <div class="col-md-8"><sa-input-number [(text)]="beaconsensor.maxValue" [title]="'Max Value'" [required]="'none'" (hasChanged)="sensorhaschanged()"></sa-input-number>
                        </div>
                        <div class="col-md-4 align-self-end">
                            <div>{{beaconsensor.sensorunits}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <sa-input-number [(text)]="beaconsensor.maxDistance" [title]="'Max Distance [feet]'" [required]="'none'"></sa-input-number>
                    <br><br>
                    <sa-input-number [(text)]="beaconsensor.threshold" [title]="'Threshold'" [required]="'none'"></sa-input-number>
                </div>
            </div>
            <br>
            <button *ngIf="beaconsensor.id > 0" class="btn btn-primary" (click)="save()">Save</button>
            <button *ngIf="beaconsensor.id == 0" class="btn btn-primary" (click)="save()">Add</button>
            <button class="btn btn-secondary" style="float:right" (click)="showModal = false">Close Modal</button>
            <!-- <button class="btn btn-primary" (click)="clearBeaconSensor()" style="float:right">Clear</button> -->
            <div *ngIf="validationObject.result == false">
                <b>Validation Error</b>
                <div *ngFor="let m of validationObject.messages">
                    {{m}}
                </div>
            </div>
        </div>
        
    </div>
</div>
<!-- Debugging -------------------------------------------------------------------------------------->
<div hidden="hidden">
    <hr>
    {{beacons | json}}
    <br>
    {{sensors | json}}
    <br>
    {{beaconsensors | json}}
</div>